import { render } from "./EmergencyBroadcast.vue?vue&type=template&id=a0810f9c&scoped=true"
import script from "./EmergencyBroadcast.vue?vue&type=script&lang=js"
export * from "./EmergencyBroadcast.vue?vue&type=script&lang=js"

import "./EmergencyBroadcast.vue?vue&type=style&index=0&id=a0810f9c&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0810f9c"]])

export default __exports__